import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { commonSlice } from '../../state/reducers/common';
import { getSidebarItems } from './SidebarConfig';

function TemporaryDrawer() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const orgId = useSelector((state) => state.common.orgId);
  const subadmin = useSelector((state) => state.common.subAdminBoolean);
  const orgName = useSelector((state) => state.common.orgName);

  const [selectedItem, setSelectedItem] = useState(null);

  const sidebarItems = getSidebarItems(subadmin, theme);

  useEffect(() => {
    const { pathname } = location;
    const matchingItem = sidebarItems.find(({ path }) =>
      pathname.includes(path)
    );
    setSelectedItem(matchingItem);
  }, [location.pathname, subadmin]);

  // ---------- SX STYLES ----------
  const drawerPaperSx = {
    background: theme.palette.other.sidebar,
    fontSize: '1.1rem',
    fontWeight: 600,
    fontFamily: 'Inter',
    color: theme.palette.other.white,
    borderColor: theme.palette.divider,
    transition: '0.2s',
    paddingRight: 0.8,
    width: '17%',
    boxSizing: 'border-box',
  };

  const containerSx = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  };

  const sidebarWrapperSx = {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 7.7,
  };

  const getItemSx = (isSelected, isOrgSettings) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingY: '12px',
    paddingLeft: isOrgSettings ? '12px' : '16px',
    marginTop: 1,
    borderRadius: 1,
    height: '45px',
    marginLeft: isOrgSettings ? '0px' : '2.4px',
    borderLeft: isSelected ? `3px solid ${theme.palette.primary.main}` : '',
    backgroundColor: isSelected ? theme.palette.other.sidebarMenuSelected : '',
    cursor: isOrgSettings ? 'not-allowed' : 'pointer',
    pointerEvents: isOrgSettings ? 'none' : 'auto',
    '&:hover': {
      backgroundColor: !isOrgSettings
        ? alpha(theme.palette.other.sidebarMenuHover)
        : 'transparent',
    },
  });

  // ---------- RENDER ----------
  return (
    <Drawer
      open
      variant="persistent"
      PaperProps={{ sx: drawerPaperSx }}
      sx={{ flexBasis: '17%', flexShrink: 0 }}
    >
      <Box role="presentation" sx={containerSx}>
        <Box sx={sidebarWrapperSx}>
          {sidebarItems.map((item) => {
            const isOrgSettings = item.label === 'Organization Settings';
            const isSelected =
              selectedItem && selectedItem.label === item.label;

            return (
              <Box
                key={item.label}
                sx={getItemSx(isSelected, isOrgSettings)}
                onClick={() => {
                  if (isOrgSettings) return;
                  setSelectedItem(item);

                  if (subadmin) {
                    dispatch(commonSlice.actions.setOrgName(orgName));
                    dispatch(commonSlice.actions.setOrg(orgId));
                  }

                  navigate(item?.path, { state: { mode: '' } });
                }}
              >
                {item?.icon}
                <Typography
                  variant="body1"
                  sx={{
                    color: isOrgSettings
                      ? theme.palette.text.disabled
                      : theme.palette.primary.main,
                  }}
                  paddingLeft={1}
                >
                  {item?.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Drawer>
  );
}

export default TemporaryDrawer;
